import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["loading", "disabled", "invalid", "inline", "leftAdornment", "rightAdornment", "size", "width", "minWidth", "maxWidth", "textAlign"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { clsx } from 'clsx';
import { InputWrapper } from '../../../internal/components/InputWrapper/InputWrapper';
import { InputWrapperInput } from '../../../internal/components/InputWrapperInput/InputWrapperInput';
import { FocusObserver } from '../../../internal/components/FocusObserver/FocusObserver';
import { NativeNumberInput } from '../../internal/components/NativeNumberInput';
import * as styles from './styles.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var NumberInput = /*#__PURE__*/React.forwardRef(function NumberInput(props, ref) {
  var loading = props.loading,
    disabled = props.disabled,
    invalid = props.invalid,
    inline = props.inline,
    leftAdornment = props.leftAdornment,
    rightAdornment = props.rightAdornment,
    size = props.size,
    width = props.width,
    minWidth = props.minWidth,
    maxWidth = props.maxWidth,
    textAlign = props.textAlign,
    rest = _objectWithoutProperties(props, _excluded);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    focused = _React$useState2[0],
    setFocused = _React$useState2[1];
  return /*#__PURE__*/_jsx(InputWrapper, {
    ref: ref,
    focused: focused,
    loading: loading,
    disabled: disabled,
    inline: inline,
    invalid: invalid,
    leftAdornment: leftAdornment,
    rightAdornment: rightAdornment,
    size: size,
    width: width,
    minWidth: minWidth,
    maxWidth: maxWidth,
    children: /*#__PURE__*/_jsx(FocusObserver, {
      onChange: setFocused,
      children: /*#__PURE__*/_jsx(NativeNumberInput, _objectSpread(_objectSpread({}, rest), {}, {
        as: InputWrapperInput,
        type: "tel",
        className: clsx(textAlign === 'center' && styles['text-align-center'], textAlign === 'right' && styles['text-align-right']),
        disabled: disabled
      }))
    })
  });
});